<template>
  <div class="d-flex flex-direction-colunm">
    <div class="bg-purple pl-3 pt-3">
      <h1>Gostaria de contatar o candidato(a)?</h1>
    </div>

    <div class="p-3">
      <label class="color-black">Assunto:</label>
      <input v-model="subject" class="form-control" />
    </div>

    <div class="p-3">
      <label class="color-black">Texto:</label>
      <textarea v-model="text" class="form-control" rows="3" />
    </div>

    <div class="d-flex justify-content-end">
      <button
        class="btn btn-primary btn-md mr-3 mb-3"
        type="button"
        @click="sendMail"
      >
        Enviar
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    candidate: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data: () => ({
    subject: null,
    text: null,
  }),
  methods: {
    sendMail() {
      const request = {
        candidate_email: "astateaset@asdgasdg.com",
        candidate_id: 123,
        subject: this.subject,
        message: this.text,
      };
      axios
        .post("/recruiters/answer_request", { request })
        .then((response) => {
          this.$emit("close");
          this.$toast.success("Email enviado!");
        })
        .catch((error) => {
          this.$toast.error("Erro ao enviar email.");
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
